import { render, staticRenderFns } from "./EsgPartnerAssessmentMgmt.vue?vue&type=template&id=2b3e7c30"
import script from "./EsgPartnerAssessmentMgmt.vue?vue&type=script&lang=js"
export * from "./EsgPartnerAssessmentMgmt.vue?vue&type=script&lang=js"
import style0 from "./EsgPartnerAssessmentMgmt.vue?vue&type=style&index=0&id=2b3e7c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports